function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { useEffect, useState } from 'react';
import cn from 'classnames';
//Стили
import './Modal.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Modal = function Modal(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, children = _ref.children, modalClassName = _ref.modalClassName, _ref$variant = _ref.variant, variant = _ref$variant === void 0 ? 'default' : _ref$variant;
    var _useState = useState(isOpen), _useState2 = _slicedToArray(_useState, 2), render = _useState2[0], setRender = _useState2[1];
    useEffect(function () {
        if (isOpen) {
            setRender(true);
        }
    }, [isOpen]);
    useEffect(function () {
        if (!render)
            return;
        var body = document.body;
        var html = document.documentElement;
        var prevOverflow = body.style.overflow;
        var prevPaddingRight = body.style.paddingRight;
        var scrollBarWidth = window.innerWidth - html.clientWidth;
        if (scrollBarWidth > 0) {
            body.style.paddingRight = "".concat(scrollBarWidth, "px");
        }
        body.style.overflow = 'hidden';
        return function () {
            body.style.overflow = prevOverflow;
            body.style.paddingRight = prevPaddingRight;
        };
    }, [render]);
    var handleTransitionEnd = function handleTransitionEnd() {
        if (!isOpen) {
            setRender(false);
        }
    };
    if (!render)
        return null;
    return /*#__PURE__*/ _jsx("div", {
        className: cn('modal', modalClassName, {
            'modal--visible': isOpen
        }),
        onClick: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn('modal__content', {
                'modal__content--trailer': variant === 'trailer'
            }),
            onClick: function onClick(e) {
                return e.stopPropagation();
            },
            role: "dialog",
            "aria-modal": "true",
            onTransitionEnd: handleTransitionEnd,
            children: [/*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "modal__close",
                    onClick: onClose,
                    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
                    children: "\u2715"
                }), children]
        })
    });
};
export default Modal;
